import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';

import { FetchDatasetParams } from '../types';

import { DirectContributionResponse, UseDirectContributionParams } from './types';

const fetchDirectContibution = async (params: FetchDatasetParams & Pick<UseDirectContributionParams, 'indicator_id'>) => {
  const { data } = await api.get(`/spold/direct_contributions`, { params });

  return data;
};

/** A negative `indicator_id` means "not known yet"; 0 is a valid id. */
const useDirectContribution = (
  { dataset_id, indicator_id }: UseDirectContributionParams,
  enabled = true,
  release?: ReleaseRef
) => {
  const { version, system_model } = useResolvedRelease(release);
  return useQuery<DirectContributionResponse, AxiosError>({
    queryKey: ['directContribution', dataset_id, indicator_id, version, system_model],
    queryFn: () => fetchDirectContibution({ version, system_model, dataset_id, indicator_id }),
    enabled: enabled && !!dataset_id && indicator_id >= 0,
  });
};

export default useDirectContribution;
